<label [class.clickable]="clickable">
  <ng-content />
  @if (hasRequiredBadge) {
    <span class="badge-required">*</span>
  }
</label>
@if (description) {
  <span class="description">
    {{ description }}
  </span>
}
